<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditOfertaDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <OfertaDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:remove="remover"
                             :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import OfertaDataTable from "../../components/shared/datatables/OfertaDataTable";
import BaseView from "../BaseView";
import {findOne,remove} from "../../api/oferta";
import CreateEditOfertaDialog from "../../components/shared/dialogs/CreateEditOfertaDialog";
import {ApiError} from "../../api/core";
import {ItemDeDominio} from "../../api/itemsDominio";
import {mapActions,mapGetters} from "vuex";

export default {
  name: "index",
  components: {CreateEditOfertaDialog, BaseView, OfertaDataTable},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'ID',
          column: 'id',
          type: 'number',
          prefix: '#'
        },
        {
          name: 'Tipo Item',
          column: 'idTipoItem',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.TIPO_ITEM
          })
        },         
        {
          name: 'Descricao',
          column: 'descricao',
          type: 'text'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {};
      this.editDialogOpened = true;
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const retorno = await findOne(objeto.id);
        this.item = retorno.dados[0];
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados da Oferta. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Oferta removida com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {           
          this.$toast.error(`Não foi possível remover a Oferta.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    },
    async getPermissoes(){
      this.getPermissaoPorItemPerfil("Oferta.cadastro",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });      
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>